import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalSearchResponse, ServiceResult } from '@data/schema/global-search-response';
import { GlobalSearchService } from '@gah-core/services/global-search.service';
import { UserStoreService } from '@gah-core/services/user-store.service';
import { TranslateService } from '@ngx-translate/core';
import { NgDynamicBreadcrumbService } from 'ng-dynamic-breadcrumb';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { GlobalSearchComponent } from '../global-search/global-search.component';

@Component({
  selector: 'app-global-search-list',
  templateUrl: './global-search-list.component.html',
  styleUrls: ['./global-search-list.component.scss'],
  providers: [GlobalSearchComponent],
})
export class GlobalSearchListComponent implements OnInit, OnDestroy {
  // @ViewChild(GlobalSearchComponent) globalSearchComponent: GlobalSearchComponent;
  territoryName: any;
  navigationSubscription: Subscription;
  snapSubscription: Subscription;
  searchResults: ServiceResult[] = [];
  searchValue: string;
  pageInfo: string = '';

  constructor(
    private router: Router,
    private userStoreService: UserStoreService,
    private activatedRoute: ActivatedRoute,
    private ngDynamicBreadcrumbService: NgDynamicBreadcrumbService,
    private spinner: NgxSpinnerService,
    private globalSearchService: GlobalSearchService,
    private translate: TranslateService,
    private gsc: GlobalSearchComponent
  ) {
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      this.territoryName = this.userStoreService.userState?.selectedTerritory?.territoryName;
      this.ngDynamicBreadcrumbService.updateBreadcrumbLabels({ territoryName: this.territoryName });
    });
  }

  ngOnInit(): void {
    this.snapSubscription = this.activatedRoute.queryParams
      .pipe(tap(() => this.spinner.show()))
      .subscribe((res) => {
        this.searchValue = res.search ?? '';
        if (this.searchValue.trim().length > 0) {
          let reqData = {
            searchKeyword: this.searchValue,
            groupTypeCd: this.userStoreService.userState.selectedTerritory?.groupTypeCode,
            territoryId: this.userStoreService.userState.selectedTerritory?.territoryId,
            autoSuggestion: false,
          };
          this.globalSearchService
            .fetchSearchResults(reqData)
            .subscribe((res: GlobalSearchResponse) => {
              this.searchResults = res.serviceResult ?? [];
              this.spinner.hide();
            });
        } else {
          this.searchResults = [];
          this.spinner.hide();
        }

        this.globalSearchService.setSearchValue(this.searchValue);
        // this.gsc.results = [];
        // this.gsc.isSearchClose = false;
        // this.gsc.setFormValue(this.searchValue);
      });
  }

  onContentReady(e: any) {
    let currentPage = e.component.pageIndex() + 1;
    let visibleRowsCount = e.component.totalCount();
    let pageSize = e.component.pageSize();
    if (visibleRowsCount > pageSize) visibleRowsCount = pageSize;
    let currentRowNumber = (currentPage - 1) * visibleRowsCount + 1;
    let pageSizeCustom = visibleRowsCount - 1;
    let lastRowNumber = currentRowNumber + pageSizeCustom;
    let totalCount = e.component.option('dataSource')?.length;
    if (lastRowNumber > totalCount) lastRowNumber = totalCount;
    if (visibleRowsCount == 0) currentRowNumber = 0;
    if (e.component.totalCount() === 0) {
      this.pageInfo = '';
    } else {
      this.translate
        .get('pagination-displaying-text', {
          range: currentRowNumber + ' - ' + lastRowNumber,
          totalNo: e.component.totalCount(),
        })
        .subscribe((res: string) => {
          this.pageInfo = res;
        });
    }
  }

  onSelectionChange(event) {
    let selectedOption = event.data ?? null;
    if (selectedOption) {
      let url = '';
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      if (selectedOption.type === 'Asset') {
        url = `assets/${selectedOption.title_id}/preview/${selectedOption.runner_asset_release_id}`;
      } else {
        url = `assets/${selectedOption.title_id}`;
      }
      this.router.navigate([url]);
    }
  }

  ngOnDestroy(): void {
    this.globalSearchService.setSearchValue(null);
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
    if (this.snapSubscription) {
      this.snapSubscription.unsubscribe();
    }
  }
}
